import { ActionTypes } from "features/Sheets/ManageSheet/actions";

type ScheduleItem = {
  [key: string]: any;
};

export const updateScheduleItemsOrder = (scheduleOrder: ScheduleItem[]) => {
  const payload = scheduleOrder.map((item: any, index: any) => ({
    ...item,
    order: index,
  }));
  return {
    type: ActionTypes.UpdateScheduleItemsOrder,
    payload,
  };
};

type LfgItem = {
  [key: string]: any;
};

export const updateLargeFormatGroupsOrder = (
  largeFormatGroupsOrder: LfgItem[],
) => {
  const payload = largeFormatGroupsOrder.map((item: any, index: any) => ({
    ...item,
    order: index,
  }));
  return {
    type: ActionTypes.UpdateLargeFormatGroupsOrder,
    payload,
  };
};
